(function(){
  var bar = document.querySelector('.lp-ship');
  if (!bar) return;
  if (bar.dataset.lpBound) return;
  bar.dataset.lpBound = '1';
  var threshold = parseFloat(bar.getAttribute('data-threshold')) || 100;
  var labelEl = bar.querySelector('.lp-ship__label');
  var remEl = bar.querySelector('.js-shipping-remaining');

  function fmt(n){ return n.toFixed(2).replace('.',','); }

  function apply(cart){
    var total = (cart.total_price || 0) / 100;
    var remaining = Math.max(0, threshold - total);
    var pct = Math.min(100, Math.round((total/threshold)*100));
    bar.style.setProperty('--lp-ship-w', pct + '%');
    if (labelEl) {
      if (remaining <= 0) {
        labelEl.classList.add('is-done');
        labelEl.innerHTML = 'Máte dopravu <strong>ZADARMO</strong>';
      } else {
        labelEl.classList.remove('is-done');
        labelEl.innerHTML = 'Do dopravy zadarmo chýba len <strong><span class="js-shipping-remaining">'+fmt(remaining)+'</span> €</strong>';
      }
    }
  }

  function refresh(){
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(apply)
      .catch(function(){});
  }

  document.querySelectorAll('.product-card__desc').forEach(function(desc){
    if (desc.dataset.toggled) return;
    desc.dataset.toggled = '1';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product-card__toggle';
    btn.innerHTML = '<span>Zobraziť viac</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>';
    desc.after(btn);
    requestAnimationFrame(function(){
      if (desc.scrollHeight <= desc.clientHeight + 2) btn.style.display = 'none';
    });
    btn.addEventListener('click', function(){
      var open = desc.classList.toggle('is-expanded');
      btn.classList.toggle('is-open', open);
      btn.querySelector('span').textContent = open ? 'Zobraziť menej' : 'Zobraziť viac';
    });
  });

  refresh();
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('cart:update', refresh);
  document.addEventListener('cart:change', refresh);
  window.addEventListener('focus', refresh);
})();